export function logEvent(eventName, data) {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
        window.gtag("event", "hts_"+eventName, { ...data })
    }
}